module.exports = __webpack_public_path__ + "static/media/6. En grises, Óleo y resina sobre madera, 94 x 120 cm, 2020 copy.1bf0de86.png";